(() => {
  window.MayLondonQuantity = (section, form, variants, events, changeFirst) => {
    const root = form.querySelector('[data-quantity-offers]');
    if (!root) return null;
    const { t, money } = window.MayLondonI18n;
    const cards = [...root.querySelectorAll('[data-quantity-card]')];
    const rows = [...root.querySelectorAll('[data-quantity-line]')];
    const lines = root.querySelector('[data-quantity-lines]');
    const primary = form.querySelector('[data-product-options-ui]');
    const error = root.querySelector('[data-quantity-error]');
    const hasOptions = Boolean(rows[0]?.querySelector('[data-piece-option]'));
    const discounted = root.dataset.quantityDiscount === 'true';
    let count = 1, current = null, initialized = false;
    const selected = new Array(5).fill(null);
    let cart = new Map();
    const updateCart = items => {
      cart = new Map();
      for (const item of items) {
        const id = String(item.variantId ?? item.variant_id ?? item.id);
        const quantity = Number(item.quantity);
        if (Number.isInteger(quantity) && quantity > 0) cart.set(id, (cart.get(id) || 0) + quantity);
      }
    };
    try { updateCart(JSON.parse(root.querySelector('[data-quantity-cart]')?.textContent || '[]')); } catch (_) {}
    const buttons = [...section.querySelectorAll('[data-product-submit], [data-mobile-sticky-submit]')];
    const rowVariant = row => {
      const controls = [...row.querySelectorAll('[data-piece-option]')];
      return controls.length ? variants.find(v => v.options.every((value, i) => value === controls[i]?.value)) : current;
    };
    const setRow = (index, variant) => {
      selected[index] = variant;
      rows[index].querySelectorAll('[data-piece-option]').forEach(control => { control.value = variant?.options[Number(control.dataset.pieceOption)] || ''; });
    };
    const rowQuantity = index => hasOptions ? Number(rows[index].querySelector('[data-piece-quantity]').value) : 1;
    const capacity = variant => !variant?.available ? 0 : variant.managed && variant.policy !== 'continue' ? Math.max(0, variant.inventory - (cart.get(String(variant.id)) || 0)) : Infinity;
    const remaining = (variant, index) => capacity(variant) - selected.slice(0, count).reduce((sum, other, i) => sum + (i !== index && other?.id === variant?.id && Number.isInteger(rowQuantity(i)) ? Math.max(0, rowQuantity(i)) : 0), 0);
    const canChoose = (variant, index) => Boolean(variant?.available) && remaining(variant, index) >= Math.max(1, rowQuantity(index));
    const prefixMatches = (variant, row, position, value) => variant.options[position] === value && variant.options.slice(0, position).every((v, i) => !row.querySelector(`[data-piece-option="${i}"]`).value || v === row.querySelector(`[data-piece-option="${i}"]`).value);
    const entries = quantity => selected.slice(0, quantity).map((variant, index) => ({ variant, quantity: quantity === count ? rowQuantity(index) : 1 }));
    const totals = quantity => {
      const choices = entries(quantity).filter(item => item.quantity > 0 && Number.isInteger(item.quantity));
      const subtotal = choices.reduce((sum, item) => sum + (item.variant?.price || 0) * item.quantity, 0);
      const compare = choices.reduce((sum, item) => sum + Math.max(item.variant?.price || 0, item.variant?.compare || 0) * item.quantity, 0);
      const percent = discounted ? Math.min(20, Math.max(0, quantity - 1) * 5) : 0;
      return { known: choices.every(item => item.variant), total: Math.round(subtotal * (100 - percent) / 100), compare };
    };
    const cartItems = () => {
      const choices = entries(count);
      if (choices.some(item => !Number.isInteger(item.quantity) || item.quantity < 0 || item.quantity > count) || choices.reduce((sum, item) => sum + item.quantity, 0) !== count) throw new Error(t('quantity_count_error', { count }));
      const grouped = new Map();
      for (const { variant, quantity } of choices) {
        if (!quantity) continue;
        if (!variant) throw new Error(t('choose_all_options'));
        if (!variant.available) throw new Error(t('sold_out'));
        grouped.set(variant.id, (grouped.get(variant.id) || 0) + quantity);
      }
      return [...grouped].map(([id, quantity]) => {
        const variant = variants.find(v => v.id === id);
        if (quantity > capacity(variant)) throw new Error(t('quantity_stock_error'));
        return { id, quantity };
      });
    };
    const render = () => {
      const active = cards[count - 1];
      cards.forEach(card => {
        const quantity = Number(card.dataset.quantityCard);
        const { known, total, compare } = totals(quantity);
        card.querySelector('[data-quantity-price]').textContent = known ? money(total) : t('unavailable');
        const previous = card.querySelector('[data-quantity-compare]');
        previous.hidden = !known || compare <= total;
        previous.textContent = money(compare);
        card.classList.toggle('is-selected', card === active);
        const radio = card.querySelector('[data-quantity-choice]');
        radio.disabled = variants.reduce((sum, variant) => sum + capacity(variant), 0) < quantity || form.dataset.busy === 'true';
        card.classList.toggle('is-unavailable', radio.disabled);
        card.title = radio.disabled ? t('quantity_insufficient') : '';
      });
      lines.hidden = count === 1;
      const missing = root.querySelector('[data-quantity-missing]');
      if (missing) missing.hidden = count === 1;
      const guide = root.querySelector('[data-quantity-guide]');
      if (guide) guide.hidden = count === 1;
      rows.forEach((row, index) => {
        row.hidden = index >= count;
        const amount = row.querySelector('[data-piece-quantity]');
        amount.max = String(Math.min(count, selected[index] ? Math.max(0, remaining(selected[index], index)) : count));
        amount.disabled = index >= count || form.dataset.busy === 'true';
        row.querySelector('[data-piece-quantity-label]').hidden = count === 1 || !hasOptions;
        row.classList.toggle('quantity-offer__line--inactive', rowQuantity(index) === 0);
        row.querySelectorAll('[data-piece-option]').forEach(control => {
          control.disabled = index >= count || rowQuantity(index) === 0 || form.dataset.busy === 'true';
          const position = Number(control.dataset.pieceOption);
          for (const option of control.options) {
            if (!option.value) { option.disabled = true; continue; }
            const matches = variants.filter(v => prefixMatches(v, row, position, option.value));
            const possible = matches.some(v => canChoose(v, index));
            const reason = !matches.length ? t('unavailable') : !matches.some(v => v.available) ? t('sold_out') : t('quantity_insufficient');
            option.disabled = !possible;
            option.textContent = option.value + (possible ? '' : ' - ' + reason);
          }
          control.setAttribute('aria-invalid', String(rowQuantity(index) > 0 && !canChoose(selected[index], index)));
        });
        const status = row.querySelector('[data-piece-status]');
        if (status) {
          const message = !hasOptions ? t('quantity_no_options') : !rowQuantity(index) ? '' : !selected[index] ? t('choose_all_options') : !selected[index].available ? t('sold_out') : !canChoose(selected[index], index) ? t('quantity_insufficient') : '';
          status.textContent = message; status.hidden = !message;
        }
      });
      if (primary) {
        primary.hidden = count > 1;
        primary.querySelectorAll('[data-product-option]').forEach(input => {
          const position = Number(input.dataset.optionPosition);
          const matches = variants.filter(v => v.options[position] === input.value && v.options.slice(0, position).every((value, i) => value === current?.options[i]));
          const available = matches.some(v => canChoose(v, 0));
          const message = available ? '' : !matches.length ? t('unavailable') : !matches.some(v => v.available) ? t('sold_out') : t('quantity_insufficient');
          input.disabled = !available || form.dataset.busy === 'true';
          input.title = message || input.value;
          const label = input.nextElementSibling;
          label?.classList.toggle('is-sold-out', !available);
          const status = label?.querySelector('[data-option-stock]');
          if (status) { status.hidden = !message; status.textContent = message; }
        });
      }
      let message = '';
      try { cartItems(); } catch (e) { message = e.message; }
      error.hidden = !message;
      error.textContent = message;
      const { known, total, compare } = totals(count);
      const totalText = known ? money(total) : t('unavailable');
      root.querySelector('[data-quantity-total]').textContent = totalText;
      const originalTotal = root.querySelector('[data-quantity-total-compare]');
      if (originalTotal) { originalTotal.hidden = !known || compare <= total; originalTotal.textContent = money(compare); }
      section.querySelectorAll('[data-sticky-product-price]').forEach(el => { el.textContent = totalText; });
      buttons.forEach(button => { button.disabled = Boolean(message) || form.dataset.busy === 'true'; });
    };
    root.addEventListener('change', event => {
      if (event.target.matches('[data-quantity-choice]')) {
        if (event.target.disabled) return;
        const nextCount = Number(event.target.value);
        const previousCount = count;
        count = nextCount;
        rows.forEach(row => { row.querySelector('[data-piece-quantity]').value = '1'; });
        for (let index = previousCount; index < nextCount; index++) setRow(index, null);
        for (let index = previousCount; index < nextCount; index++) setRow(index, canChoose(current, index) ? current : null);
      }
      if (event.target.matches('[data-piece-option]')) {
        const row = event.target.closest('[data-quantity-line]');
        const index = rows.indexOf(row), position = Number(event.target.dataset.pieceOption);
        let variant = rowVariant(row);
        if (!canChoose(variant, index)) variant = variants.find(v => canChoose(v, index) && prefixMatches(v, row, position, event.target.value));
        if (variant) setRow(index, variant);
        else selected[index] = null;
        if (index === 0 && variant) changeFirst(variant);
      }
      render();
    }, events);
    root.addEventListener('input', event => {
      if (event.target.matches('[data-piece-quantity]')) render();
    }, events);
    form.mayLondonItems = cartItems;
    document.addEventListener('cart:updated', event => {
      if (!Array.isArray(event.detail?.items)) return;
      updateCart(event.detail.items); render();
    }, events);
    root.hidden = false;
    return { available: variant => canChoose(variant, 0), update(variant) {
      if (!initialized) { rows.forEach((_, i) => setRow(i, variant)); initialized = true; }
      if (current?.id !== variant?.id || count === 1) setRow(0, variant);
      current = variant;
      render();
    } };
  };
})();
